import { render, staticRenderFns } from "./AxPageNotification.vue?vue&type=template&id=55204a04&scoped=true&"
import script from "./AxPageNotification.vue?vue&type=script&lang=ts&"
export * from "./AxPageNotification.vue?vue&type=script&lang=ts&"
import style0 from "./AxPageNotification.vue?vue&type=style&index=0&id=55204a04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55204a04",
  null
  
)

export default component.exports